module.exports = __webpack_public_path__ + "img/icon-activity-news-active.861624cb.svg";